import { render, staticRenderFns } from "./PanelsTable.vue?vue&type=template&id=ac0bfab6&scoped=true&"
import script from "./PanelsTable.vue?vue&type=script&lang=js&"
export * from "./PanelsTable.vue?vue&type=script&lang=js&"
import style0 from "./PanelsTable.vue?vue&type=style&index=0&id=ac0bfab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0bfab6",
  null
  
)

export default component.exports